module.exports = __webpack_public_path__ + "public/SiteImages/becomeHostBg.svg?da03519e";